import { call, put, takeLatest } from "redux-saga/effects";
import { addDocumets } from "./documentsAddApi";
import {
  addDocumentStart,
  addDocumentSuccess,
  addDocumentFailure,
} from "./documentsSlice";
import { showToast } from "../../../components";

function* addDocumentSaga(action) {
  try {
    const { onSuccess } = action.payload;
    const result = yield call(addDocumets, action.payload);

    if (result.success) {
      if(onSuccess){
      onSuccess(result.data);
      }
      console.log("result", result);
      yield put(addDocumentSuccess(result.data.data));
      //showToast("success", "Document added successfully");
      //showToast("Document added successfully", "success");
    } else {
      yield put(addDocumentFailure(result.error));
      showToast(result.error, "error");
    }
  } catch (error) {
    yield put(addDocumentFailure(error.message));
    showToast(error.message, "error");
  }
}

export function* watchDocuments() {
  yield takeLatest(addDocumentStart.type, addDocumentSaga);
}
